export const authSectionCard =
	"bg-white rounded-xl border border-[#E2E8F0] p-4 sm:p-5 shadow-[0_4px_20px_rgba(39,106,166,0.07)]";

export function AuthCardTopAccent() {
	return (
		<div
			className="h-1 -mx-4 -mt-4 mb-4 sm:-mx-5 sm:-mt-5 sm:mb-5 rounded-t-xl bg-gradient-to-l from-cta via-[#3d8fd4] to-darkBlue"
			aria-hidden
		/>
	);
}
